import { NgModule } from '@angular/core';
import {
  CurrencyPipe,
  DatePipe,
  KeyValuePipe,
  PercentPipe,
} from '@angular/common';
import { BaseModule, DISTINCT_ITEMS_SOURCE } from '@shared';
import { SharedDataModule } from '@shared-data';
import {
  AlertsBannerComponent,
  PricingComponent,
  AvailabilityComponent,
  SchedulerComponent,
  PendingChangesGridComponent,
  AvailabilityComboChangesetComponent,
  UpchargeChangesetComponent,
  ComboChangesetComponent,
  OverrideGridComponent,
  SyncButtonComponent,
  SubstitutionChangesetComponent,
  LtoChangesetComponent,
  BundleChangesetComponent,
  KidMealChangesetComponent,
  ComboMarkupInfoComponent,
  ComboDiscountInfoComponent,
  DeliveryManagementComponent,
} from './components';
import { RestaurantItemComponent } from './restaurant-item.component';
import { RestaurantItemRoutingModule } from './restaurant-item-routing.module';
import { RestaurantItemService } from './services';
import { FilterChangesetTypePipe } from './pipes';
import { BaseAvailabilityChangesetComponent } from './components/base-availability-changeset/base-availability-changeset.component';
import { BasePricingChangesetComponent } from './components/base-pricing-changeset/base-pricing-changeset.component';
@NgModule({
  declarations: [
    ComboChangesetComponent,
    AlertsBannerComponent,
    SchedulerComponent,
    PricingComponent,
    AvailabilityComponent,
    RestaurantItemComponent,
    SyncButtonComponent,
    PendingChangesGridComponent,
    FilterChangesetTypePipe,
    AvailabilityComboChangesetComponent,
    UpchargeChangesetComponent,
    OverrideGridComponent,
    SubstitutionChangesetComponent,
    LtoChangesetComponent,
    BundleChangesetComponent,
    BaseAvailabilityChangesetComponent,
    BasePricingChangesetComponent,
    KidMealChangesetComponent,
    ComboMarkupInfoComponent,
    ComboDiscountInfoComponent,
    DeliveryManagementComponent,
  ],
  imports: [BaseModule, RestaurantItemRoutingModule, SharedDataModule],
  exports: [
    RestaurantItemComponent,
    AlertsBannerComponent,
    SyncButtonComponent,
  ],
  providers: [
    PercentPipe,
    DatePipe,
    CurrencyPipe,
    KeyValuePipe,
    RestaurantItemService,
    // Values of the checkbox list of app-custom-filter on the pricing and
    // availability grids
    { provide: DISTINCT_ITEMS_SOURCE, useExisting: RestaurantItemService },
  ],
})
export class RestaurantItemModule {}
